// extracted by mini-css-extract-plugin
module.exports = {"root__div":"EarningItem_root__div__1Nc1S","clickable":"EarningItem_clickable__1MSAT","earned_amount_text":"EarningItem_earned_amount_text__3HUEh"};